import { Router } from '@angular/router';
import { BLoginService } from './bLogin.service';
var BAuthGuard = (function () {
    function BAuthGuard(bLoginService, router) {
        this.bLoginService = bLoginService;
        this.router = router;
    }
    BAuthGuard.prototype.canActivate = function () {
        if (this.bLoginService.isLoggedIn()) {
            return true;
        }
        else {
            this.router.navigate(['unauthorized']);
            return false;
        }
    };
    return BAuthGuard;
}());
export { BAuthGuard };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bAuthGuard.service.ts.pre-build-optimizer.js